import { Box, Button, Grid, Typography } from '@mui/material';
import { getApprover } from 'API/approverApi';
import { requestFormApproverColumnName } from 'Helpers/dashbordDataRows';
import { transformApproverData } from 'Helpers/utils';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddEditApprover from './AddEditApprover';
import ApproverListTable from './ApproverListTable';
import './ManageApprover.scss';

const ManageApprover = () => {
  // State to manage popup visibility
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const dispatch = useDispatch();
  const { approverData: rawApproverData } = useSelector((state) => state.approver);

  // New state for transformed data
  const [transformedData, setTransformedData] = useState([]);

  // State for selected row when editing
  const [selectedRow, setSelectedRow] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    dispatch(getApprover()).unwrap();
  }, [dispatch]);

  useEffect(() => {
    if (rawApproverData) {
      const transformed = transformApproverData(rawApproverData);
      setTransformedData(transformed);
    }
  }, [rawApproverData]);

  const handleAddApprover = () => {
    setSelectedRow(null);
    setIsEditing(false);
    setIsPopupOpen(true);
  };

  const handleEditApprover = (row) => {
    setSelectedRow(row.originalData); // Use originalData for editing
    setIsEditing(true);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setSelectedRow(null);
    setIsEditing(false);
  };

  return (
    <Box className="approver-management-parent">
      <Box className="approver-management-main">
        <Grid container spacing={2} className="approver-management-header">
          <Grid item>
            <Typography variant="h6" className="approver-management-title">
              {t('dashboard.approver-management')}
            </Typography>
          </Grid>
          <Grid item className="action-block">
            <Grid item>
              <Button
                variant="contained"
                className="add-approver-button"
                onClick={handleAddApprover}>
                {t('approverManagement.addApprover')}
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <ApproverListTable
          rowsHead={requestFormApproverColumnName}
          rowsData={transformedData} // Use transformed data here
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          handleEditApprover={handleEditApprover}
        />

        <AddEditApprover
          isOpen={isPopupOpen}
          onClose={handleClosePopup}
          isEditing={isEditing}
          editData={selectedRow} // Pass the original data for editing
        />
      </Box>
    </Box>
  );
};

export default ManageApprover;
